import React, { useState } from "react";
import WorkflowDetails from "./components/WorkflowDetails";
import ConditionsSetup from "./components/ConditionsSetup";
import ApproversSetup from "./components/ApproversSetup";
import AdvancedSettings from "./components/AdvancedSettings";

const WorkflowSetup = () => {
  const [workflowDetails, setWorkflowDetails] = useState({
    name: "",
    active: false,
    priority: 50,
  });

  const [conditions, setConditions] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [advancedSettings, setAdvancedSettings] = useState({
    enableParallelApprovals: false,
    submissionBlockingMessage: "",
    validationErrorMessage: "",
    approverLimit: "",
  });

  // Example module fields (replace with dynamic fields based on module)
  const moduleFields = ["Total", "Line BU/DU", "Contains ADMIN FACI"];

  const saveWorkflow = () => {
    // Validate the workflow setup
    if (!workflowDetails.name) {
      alert("Workflow name is required!");
      return;
    }
    if (conditions.length === 0) {
      alert("At least one condition is required!");
      return;
    }
    if (approvers.length === 0) {
      alert("At least one approver is required!");
      return;
    }

    // Simulate saving workflow
    console.log("Saving workflow:", {
      ...workflowDetails,
      conditions,
      approvers,
      advancedSettings,
    });
    alert("Workflow saved successfully!");
  };

  return (
    <div className="p-6 space-y-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold text-gray-800">Workflow Setup</h1>
      <div className="space-y-6">
        <WorkflowDetails
          details={workflowDetails}
          onChange={setWorkflowDetails}
        />
        <ConditionsSetup
          conditions={conditions}
          onChange={setConditions}
          moduleFields={moduleFields}
        />
        <ApproversSetup approvers={approvers} onChange={setApprovers} />
        {/* <AdvancedSettings
          settings={advancedSettings}
          onChange={setAdvancedSettings}
        /> */}
      </div>
      <button
        onClick={saveWorkflow}
        className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600 shadow-md mt-6"
      >
        Save Workflow
      </button>
    </div>
  );
};

export default WorkflowSetup;
